<template>
<div class="popup" v-cloak v-show="detailedProgressShow">
    <div class="content detailedProgress" id="detailedProgress">
        <div class="title">
            {{$t('language.popup.cloudExploerPopup.detailedProgress')}}
            <div class="icon white-close dialog-close" @click="detailedProgressShow=false"></div>
        </div>
        <div class="progress-body">
            <div class="detailed-content">
                <el-tabs v-model=activeName :before-leave='leaveTab'>
                    <el-tab-pane :label="$t('language.popup.allTasks')" name="first">
                        <tab1 ref="tab1"></tab1>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('language.popup.successful')" name="second">
                        <tab2 ref="tab2"></tab2>
                    </el-tab-pane>
                    <el-tab-pane>
                        <span slot="label" name="third" class="transfer-vip">
                            <span>{{$t('language.popup.unfinished')}}</span>
                        </span>
                        <tab3 ref="tab3"></tab3>
                    </el-tab-pane>
                </el-tabs>
                <div class="icon-util broom broom-position" :data-title="$t('language.common.cleanList')" @click.stop="cleanList()"></div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
import tab1 from "@/components/common/tabs/tabs_detailed_progress/tab_all_tasks";
import tab2 from "@/components/common/tabs/tabs_detailed_progress/tab_successful_tasks";
import tab3 from "@/components/common/tabs/tabs_detailed_progress/tab_unfinished_tasks";
import cloudExploerUtils from "@/js/workspace/cloud_exploer_util.js";
export default {
    components: {
        tab1,
        tab2,
        tab3
    },
    mounted() {

    },
    data: function () {
        return {
            detailedProgressShow: false,
            tabs: [{
                    name: this.$t("language.popup.allTasks")
                },
                {
                    name: this.$t("language.popup.successful")
                },
                {
                    name: this.$t("language.popup.unfinished")
                }
            ],
            indexCurrent: -1,
            tabView: "tab1",
            tabBarClass: "detailed-bar-one",
            activeName: "first",
            dataNum: 0
        };
    },
    watch: {
        detailedProgressShow(newValue,oldValue){
            this.$store.state.detaleProgressShow=newValue;
        },
        '$store.state.detaleProgressShow': {
            handler:function(newV,oldV){
                this.detailedProgressShow = newV;
            }
        }
    },
    methods: {
        leaveTab(activeName,oldActiveName){
            this.$store.state.detailTaskOpen=false;
           //当切换界面时，将所有打开的界面关闭
              $.each(this.$store.state.detailedProgrssData,function(k,kItem){
                    if(kItem.open){
                        kItem.open=false;
                    }
               });
                 $.each(this.$store.state.detailTabSuccess,function(m,mItem){
                    if(mItem.open){
                        mItem.open=false;
                    }
               });
                 $.each(this.$store.state.detailTabUnfinished,function(n,nItem){
                    if(nItem.open){
                        nItem.open=false;
                    }
               });

        },
        //清除所有的数据
        deleteAllData() {
            let that = this;
            let allData = Object.assign([], that.$refs.tab1.taskDatas);
            if (allData.length) {
                let removeData=new cloudExploerUtils.removeData(commonUtils.getUser().id,type,allData[this.dataNum].taskId);
                that.Utils.doTasksRequest('remove_completed_task', removeData).then(response => {
                    that.dataNum = that.dataNum + 1;
                    if (that.dataNum < that.$refs.tab1.taskDatas.length) {
                        that.deleteAllData();
                    } else {
                        that.dataNum = 0;
                    }
                });
            }
        },//切换tab界面
        tabChange: function (tab) {
            this.tabView = tab;
            //当切换界面时，将打开的界面关闭
              $.each(this.$store.state.detailedProgrssData,function(k,kItem){
                    if(kItem.open){
                        kItem.open=false;
                    }
               });
        },
        cleanList() {//清除数据
            let that = this;
            //that.dataNum = 0;
            //that.deleteAllData();
            let detailItems = Object.assign([], that.$store.state.detailedProgrssData);
            let snaptasks = Object.assign([], that.$store.state.retryItems);
            let snapTaskNameArr = [];
            that.$store.state.detailTabSuccess=[];
            that.$store.state.detailTabUnfinished=[];
            $.each(snaptasks, function (k, snapItem) {
                snapTaskNameArr.push(snapItem.name)
            });
            let readyArr = [];
            if (detailItems.length) {
                $.each(detailItems, function (j, detailItem) {
                    if (snapTaskNameArr.includes(detailItem.sourceFilename)&&detailItem.status<3) {
                        readyArr.push(detailItem);
                    }
                    if (j == detailItems.length - 1) {
                        that.$store.commit("setDetailedProgrssDataEmpty", readyArr);
                    }
                });
            }
        }
    }
};
</script>

<style>
#detailedProgress {
    width: 680px;
    /*no*/
    height: 510px;
    /*no*/
}

.progress-body {
    width: 100%;
    height: 470px;
    /*no*/
}

.detailed-bar-one {
    width: 60px !important;
    /*no*/
    transform: translateX(7px);
    /*no*/
}

.detailed-bar-two {
    width: 70px !important;
    /*no*/
    transform: translateX(105px);
    /*no*/
}

.detailed-bar-three {
    width: 70px !important;
    /*no*/
    transform: translateX(215px);
    /*no*/
}

.broom-position {
    position: absolute;
    left: 650Px;
    top: 53Px;
}

.detailed-content {
    width: 100%;
    height: 468Px;
    box-sizing: border-box;
    padding: 0px 15px 0px 15px;
    /*no*/

}

.broom-position:hover:after {
    content: attr(data-title);
    position: absolute;
    border: #8a96e3 solid 1px;
    /*no*/
    background: #fff;
    font-size: 13px;
    /*no*/
    color: rgba(0, 0, 0, 0.6);
    padding: 2px;
    /*no*/
    border-radius: 2px;
    /*no*/
    z-index: 1600;
    top: 25px;
    /*no*/
    left: -65px;
    /*no*/
    height: 20px;
    /*no*/
    line-height: 20px;
    /*no*/
    white-space: nowrap;
}

/*定义滑块，内阴影及圆角*/
.all-detail-task::-webkit-scrollbar {
    width: 6px;
    /*no*/
    height: 0px;
    /*no*/
    background-color: #fff;

}

.all-detail-task::-webkit-scrollbar-thumb {
    border-radius: 5px;
    /*no*/
    background-color: #becae4;

}

.tabs-title {
    box-sizing: border-box;
    padding: 0px 20px 0px 20px;
    /*no*/
}

#detailedProgress #tab-first,
#detailedProgress #tab-second,
#detailedProgress #tab-third {
    font-size: 14px;
    /*no*/
    height: 40px;
    /*no*/
    line-height: 40px;
    /*no*/
    position: relative;
}

#detailedProgress .is-top {
    margin: 0 !important;

}

#detailedProgress #tab-second {
    font-size: 14Px;
    height: 40Px;
    position: relative;
    top: -5Px !important;
}
#detailedProgress #tab-2 {
    font-size: 14Px;
    height: 40Px;
    position: relative;
    top: -5Px !important;
}
#detailedProgress #tab-first {
    font-size: 14Px;
    height: 40Px;
    position: relative;
    top: -5Px !important;
}
.all-detail-task {
    width: 100%;
    height: 423Px;
    overflow-y: auto;
    box-sizing: border-box;
    overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/cloud_exploer_popups/detailed_progress_popup.vue